import React from "react";

import { LogoutLinkContainer } from "@components/Account/LogoutLink/logoutLink.container";
import { PageLinks } from "@components/General/PageLinks/pageLinks.component";
import { PageLinkProps } from "@components/General/PageLinks/PageLink/pageLink.component";
import { Divider } from "@components/General/Divider/divider.component";

import "./accountButtonMenu.scss";

type Props = {
    links?: Array<PageLinkProps>;
};

const AccountButtonMenu = ({ links }: Props) => {
    return (
        <div className={"account-button-menu-wrapper"}>
            <Divider className="mb-3" />
            <div className={"mx-2"}>
                <PageLinks links={links} />
            </div>
            <Divider className="mb-2" />
            <div className="mx-2">
                <LogoutLinkContainer classes={"text-decoration-none"} />
            </div>
        </div>
    );
};

export default AccountButtonMenu;
